<script>
    import R, {LOADER} from "../lib/requests";
    import {LOCATION_TYPES} from "../lib/constants";
    import {setFocusTo} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";

    export let locationId = null;
    export let parent = null;
    export let regions = [];
    export let closeCallback;

    let location = null;
    let types = [];

    const initialize = () => {
        Object.keys(LOCATION_TYPES).map(key => {
            types.push({id: key, name: LOCATION_TYPES[key]});
        });

        if (!parent) {
            parent = regions[0];
        }

        if (locationId == 0) {
            location = {
                id: 0,
                parent_id: parent.id,
                type_id: 0,
                hotel_id: 0,
                code: '',
                name: '',
                level: parent.level + 1,
                is_start_point: 0,
                is_local: 1,
                is_active: 1,
            }
            setFocusTo('locationName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            location = result;
            setFocusTo('locationName');
        };

        const onFailure = err => {
        };

        R.handle(R.location.details, locationId, onSuccess, onFailure, LOADER.POPUP);
    };

    const close = (param) => {
        location = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }


    const save = () => {
        const onSuccess = result => {
            close(result);
        }

        const onFailure = err => {
        };

        location.name = location.name.trim();
        if (!location.name) {
            Notifier.showError("Enter the name for the location!");
            setFocusTo("locationName");
            return;
        }

        let action = locationId == 0 ? 'create' : 'edit';
        R.handle(R.location[action], location, onSuccess, onFailure, LOADER.POPUP);
    }

    initialize();

</script>

{#if location}
    <Modal title="Location" on:close="{ close }">
        <div slot="body">
            {#if location.level > 0}
                <div class="form-group">
                    <label>Region</label>
                    <select class="form-select" bind:value="{ location.parent_id }">
                        {#each regions as item}
                            <option value="{ item.id }">{ item.name }</option>
                        {/each}
                    </select>
                </div>
            {/if}
            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" id="locationName" bind:value="{ location.name }"
                       required>
            </div>
            {#if location.level > 0}
                <div class="form-group">
                    <label>Code</label>
                    <input type="text" class="form-control" bind:value="{ location.code }">
                </div>

                <div class="form-group">
                    <label>Type</label>
                    <select class="form-select" bind:value="{ location.type_id }" disabled={ location.hotel_id > 0 }>
                        {#each types as item}
                            <option value="{ item.id }">{ item.name }</option>
                        {/each}
                    </select>
                </div>
                <div class="form-group">
                    <Checkbox label="Is start point" bind:checked={ location.is_start_point }
                              disabled={ location.hotel_id > 0 }/>
                </div>
                <div class="form-group">
                    <Checkbox label="Show in local transfers" bind:checked={ location.is_local }
                              disabled={ location.hotel_id > 0 }/>
                </div>
                <div class="form-group">
                    <Checkbox label="Active location" bind:checked={ location.is_active }
                              disabled={ location.hotel_id > 0 }/>
                </div>
            {/if}

            <hr>
            <div class="text-end">
                <div class="btn btn-link me-2" on:click="{ () => close() }">Close</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Save</button>
            </div>
        </div>
    </Modal>
{/if}